// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3-8vr","left":"styles_left__1P0RU","desktopActions":"styles_desktopActions__lYpHd","title":"styles_title__12-rq"};